export default {
    props: {},
    data: function () {
        return {};
    },
    methods: {
        autosize() {
            let el = this.$refs['autoSize'];

            el.style.overflowY = 'hidden';
            el.style.resize = 'none';


            setTimeout(function () {
                el.style.height = 'auto';
                el.style.height = (el.scrollHeight + 8) + 'px';
            }, 10);
        }
    },
    computed: {},
    watch: {},
    mounted() {
        this.autosize();
    }
};
